// components/Loader.jsx
import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-dot"></div>
    </div>
  );
};

export default Loader;
